import { lazy, Suspense, type ReactNode } from 'react';
import type { RouteObject } from 'react-router';
import { PageLoader } from '@dezza/ui';

const CustomersPage = lazy(() => import('./pages/CustomersPage'));
const CustomerFormPage = lazy(() => import('./pages/CustomerFormPage'));
const CustomerDetailPage = lazy(() => import('./pages/CustomerDetailPage'));

const S = ({ children }: { children: ReactNode }) => <Suspense fallback={<PageLoader />}>{children}</Suspense>;

/** Rotas desta área (dentro do shell autenticado). */
export const routes: RouteObject[] = [
  { path: 'clientes', element: <S><CustomersPage /></S> },
  { path: 'clientes/novo', element: <S><CustomerFormPage /></S> },
  { path: 'clientes/:id', element: <S><CustomerDetailPage /></S> },
  { path: 'clientes/:id/editar', element: <S><CustomerFormPage /></S> },
];

/** Rotas protegidas sem o shell (ex.: impressão). */
export const fullscreenRoutes: RouteObject[] = [];
